import React from 'react';
import { Card } from './ui/card';
import { Quote } from 'lucide-react';

const QuoteCard = ({ quote }) => {
  if (!quote) return null;
  
  return (
    <Card 
      data-testid="quote-card"
      className="p-6 bg-paper-light shadow-lifted border-2 border-brown/40 relative overflow-hidden"
    >
      {/* Decorative quote mark */}
      <div className="absolute top-0 left-4 text-6xl text-brown/15 font-serif select-none leading-none">
        "
      </div>
      
      {/* Decorative herb */}
      <div className="absolute top-2 right-2 text-xl opacity-30">🌿</div>
      
      <div className="flex items-start gap-4 relative z-10">
        <div className="w-10 h-10 rounded-full bg-brown/10 flex items-center justify-center flex-shrink-0 border border-brown/20">
          <Quote className="w-5 h-5 text-brown" />
        </div>
        <div>
          <p className="font-accent text-lg text-ink-900 italic leading-relaxed mb-2">
            "{quote.text}"
          </p>
          <p className="text-sm text-ink-500 font-handwritten text-lg">
            — {quote.author}
          </p>
        </div>
      </div>
    </Card>
  );
};

export default QuoteCard;
